const downloadOptions = {
  DOWNLOAD_ON_COMPUTER: 'download-on-computer',
  OPEN_IN_NEW_TAB: 'open-in-new-tab',
};

export default downloadOptions;
